<template>
<div class="main">

<div class="container">
    <div class="wrapper">
    <h3>Tak for din ansøgning om at få en fuldmagt til levering af pakker med GLS. </h3>
    <p>Vi behandler nu din ansøgning i dit lokale depot og vender tilbage til dig, hvis der skulle opstå spørgsmål hertil. </p>
    <p>Vi behandler løbende nye ansøgninger og sender dit nye fuldmagtskilt hurtigst muligt. Når du modtager dit nye fuldmagtsskilt skal du hænge det op, som angivet i din ansøgning.  </p>
    <p>Venlig hilsen</p>
    <img  alt="gls"  src="../assets/Mini_logo.png" height="auto" width="25%"/>
    </div>
</div>

</div>
</template>

<script>
    export default {
        name: "Complete"
    }
</script>
<style lang="scss" scoped>
    #app {
        font-family: "thesansplain", Verdana, sans-serif;
    }
    .container{
        max-width: 800px;
        display: flex;
        flex-direction: column;
        .topimage{
            width:100%;
            height:auto;

        }
    }
    .wrapper{
        padding:10px;
        flex-direction: column;
        @media screen and (min-width:800px) {
            display: flex;
            justify-content: center;
            border: 1px solid #d6d6d6;
            padding: 38px;
            box-shadow: #d6d6d6 0px 0px 30px
        }
    }
    .main {
        max-width: 800px;
        width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        margin-bottom: 1000px;
        @media screen and (max-width: 800px) {
            flex-direction: column-reverse;
        }

        .logo {
            max-width: 300px;
            width: 40%;
            display: flex;
            flex-direction: column;
            @media screen and (max-width: 800px){
                flex-direction: row;
            }
            button{
                align-self: center;
                margin-top:auto;
                @media screen and (max-width: 800px){
                    display:none;
                }
            }

            img {
                width: 100%;
            }
            @media screen and (max-width: 1080px) {
                max-width: calc(600 / 19.2) * 1vw;
            }
            @media screen and (max-width: 800px) {
                display: flex;
                justify-content: center;
                width: 100%;
                max-width: 100%;
                img {
                    width: 50%;
                }
            }
        }
    }
</style>
